import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import NavigationBar from "./components/NavigationBar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./components/Home";
import AboutUs from "./components/About/AboutSection";
import EnglishProgram from "./components/Program/EnglishTuitionSection";
import ContactUs from "./components/Contact/ContactSection";
import TermsAndConditions from "./components/TermsAndConditions";
import PrivacyPolicy from "./components/PrivacyPolicy";

const App = () => {
  return (
    <>
      <Helmet>
        <title>Learn English Online | Top-Rated Courses & Expert Tutors</title>
        <meta name="description" content="Boost your English skills with our top-rated courses taught by expert tutors. Learn online at your own pace!" />
        <meta name="keywords" content="Learn English online, English courses, expert tutors, English proficiency, language learning, online classes" />
        <meta name="author" content="I Excel Management & Services" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Learn English Online | Top-Rated Courses & Expert Tutors" />
        <meta property="og:description" content="Boost your English skills with our top-rated courses taught by expert tutors. Learn online at your own pace!" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.iexcel.my" />
        <meta property="og:image" content="https://www.iexcel.my/images/iExcel_English.png" />
      </Helmet>
      <ScrollToTop />
      <NavigationBar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/programs" element={<EnglishProgram />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
      </Routes>
      <Footer />
    </>
  );
};

export default App;